import { baseApi } from "./baseApi";

const SMS_PROVIDER_BASE_URL = "/sms-provider";

export const smsProviderApi = baseApi.injectEndpoints({
  tagTypes: ["SmsProvider"],

  endpoints: (build) => ({
    addSmsProvider: build.mutation({
      query: (body) => ({
        url: SMS_PROVIDER_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "SmsProvider", id: "LIST" }],
    }),

    listSmsProviders: build.query({
      query: (params) => ({
        url: SMS_PROVIDER_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "SmsProvider",
                id: _id,
              })),
              { type: "SmsProvider", id: "LIST" },
            ]
          : [{ type: "SmsProvider", id: "LIST" }],
    }),

    getSmsProviderDetail: build.query({
      query: (smsProviderId) => `${SMS_PROVIDER_BASE_URL}/${smsProviderId}`,
      providesTags: (result, error, { _id }) => [
        { type: "SmsProvider", id: _id },
        { type: "SmsProvider", id: "LIST" },
      ],
    }),
    getDDLSmsProviderList: build.query({
      query: (params) => ({
        url: `${SMS_PROVIDER_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "SmsProvider", _id })),
              { type: "SmsProvider", id: "DDL" },
            ]
          : [{ type: "SmsProvider", id: "DDL" }],
    }),
 updateSmsProvider: build.mutation({
  query: ({ _id, ...body }) => {
    return {
      url: `${SMS_PROVIDER_BASE_URL}/${_id}`,
      method: "PUT",
      body,
    };
  },
  invalidatesTags: (result, error, { _id: id }) => [
    { type: "SmsProvider", id },
    { type: "SmsProvider", id: "LIST" },
  ],
}),
  }),
  overrideExisting: false,
});

export const {
  useAddSmsProviderMutation,
  useListSmsProvidersQuery,
  useGetDDLSmsProviderListQuery,
  useLazyGetDDLSmsProviderListQuery,
  useLazyListSmsProvidersQuery,
  useGetSmsProviderDetailQuery,
  useUpdateSmsProviderMutation,
} = smsProviderApi;
